import { usePost } from "../../../../api-client/usePost";
import { useCart } from "../../../../stores/hooks/useCart";
import { useSetInfoToast } from "../../../../stores/hooks/useSetInfoToast";
import { createSessionStorage } from "../../../../util/createSessionStorage";

// "Next Step" saves the quote without emailing the customer; the quote email goes out once the appointment step is
// done or skipped (TW-1134). An appointment request sends its own email with the quote in it, so it clears this.
type PendingQuoteEmail = {
  hasEmail: boolean;
  leadId: number;
  orderNumber: string;
};

const storage = createSessionStorage<PendingQuoteEmail | null>(
  "pendingQuoteEmail",
  null
);

export const setPendingQuoteEmail = (pending: PendingQuoteEmail): void => {
  storage.set(pending);
};

export const clearPendingQuoteEmail = (): void => {
  storage.set(null);
};

/** Sends the pending quote email for the current quote, once. */
export const useSendPendingQuoteEmail = (): VoidFunction => {
  const cart = useCart();
  const setInfoToast = useSetInfoToast();
  const { send } = usePost(
    "/retailSiteWebService/shopping/lead/sendQuoteContactLeadCustomerEmail.php"
  );

  return () => {
    const pending = storage.get();
    clearPendingQuoteEmail();
    if (!pending || pending.orderNumber !== cart?.orderNumber) {
      return;
    }
    send({
      leadId: String(pending.leadId),
      orderNumber: pending.orderNumber,
    })
      .then(() => {
        if (pending.hasEmail) {
          setInfoToast({ message: "cart.quoteEmailSent" });
        }
      })
      // The fetcher already shows an error toast.
      .catch(() => undefined);
  };
};
